<template>
  <!-- 预约登记表 -->
  <div>
    <el-row class="bg">
      <el-row>
        <el-col :span="8">
          <el-button type="warning" icon="el-icon-arrow-left" @click="back">返回</el-button>
        </el-col>
        <el-col :span="8">
          <h2 style="text-align:center">预约登记信息填写</h2>
        </el-col>
        <el-col :span="8">
        </el-col>
      </el-row>
      <el-form :inline="true" :model="addForm" class="demo-form-inline" label-width="150px">
        <el-row>
          <el-form-item label="老人姓名" prop="oldName" label-width="150px">
            <el-input v-model="addForm.oldName" style="width: 200px;"></el-input>
          </el-form-item>
          <el-form-item label="性别" label-width="100px">
            <el-select v-model="addForm.oldSex" style="width: 180px">
              <el-option label="男" value="0"></el-option>
              <el-option label="女" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="年龄" label-width="100px">
            <el-input v-model="addForm.age" placeholder="年龄" style="width: 180px;"></el-input>
          </el-form-item>

          <el-form-item label="身份证号">
            <el-input v-model="addForm.idcard" style="width: 490px;"></el-input>
          </el-form-item>
          <el-form-item label="登记时间" label-width="100px">
            <el-date-picker :clearable="true" v-model="addForm.visitTime" type="date" placeholder="请选择参观时间"
              value-format="yyyy-MM-dd" style="width: 180px;" format="yyyy-MM-dd"></el-date-picker>
          </el-form-item>
          <el-form-item label="家庭地址">
            <el-input v-model="addForm.address" style="width: 490px;"></el-input>
          </el-form-item>
          <el-form-item label="接待员" label-width="100px">
            <el-input v-model="addForm.receptionist" style="width: 180px;"></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="家属姓名" prop="oldName" label-width="150px">
            <el-input v-model="addForm.family" style="width: 200px;"></el-input>
          </el-form-item>
          <el-form-item label="联系电话" label-width="100px">
            <el-input v-model="addForm.familyPhone" style="width: 180px;"></el-input>
          </el-form-item>
          <el-form-item label="与老人的关系" label-width="100px">
            <el-input v-model="addForm.familyRelationship" style="width: 180px;"></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="家属住址" label-width="150px">
            <el-input v-model="addForm.familyAddress" style="width: 780px;"></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="老人身体情况" label-width="150px">
            <el-input v-model="addForm.health" type="textarea" :rows="3" resize="none"
              style="width: 780px;"></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="回访情况" label-width="150px">
            <el-input v-model="addForm.backContent" type="textarea" :rows="3" resize="none"
              style="width: 780px;"></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="备注" label-width="150px">
              <el-input v-model="addForm.remark" type="textarea" :rows="4" resize="none"
                style="width: 780px;"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="text-align: center">
          <el-button type="primary" @click="submitAdd">提 交</el-button>
        </el-row>
      </el-form>
    </el-row>
  </div>
</template>
<script>
import bus from "@/vuex/eventBus"; //引入eventBus,接收子界面传递的跳转指令,然后在父界面跳转,添加tab
export default {
  name: "OldReservationAdd",
  data() {
    return {
      addForm: {
        oldName: "",
        oldSex: "",
        age: "",
        idcard: "",
        visitTime: "",
        address: "",
        receptionist: "",
        health: "",
        backContent: "",
        family: "",
        familyPhone: "",
        familyAddress: "",
        familyRelationship: "",
        remark: "",
      },
    };
  },
  methods: {
    submitAdd() {
      let param = this.addForm;
      this.$postJson(
        this.addForm.id
          ? "omc/oldReservation/update"
          : "omc/oldReservation/add",
        param
      ).then(res => {
        if (res.code == 200) {
          this.$message({ message: res.message, type: "success" });
          bus.$emit('close_current_tags');
        } else {
          this.$message({
            message: res.message,
            type: "error",
          });
        }
      })
    },
    back() {
      bus.$emit('close_current_tags');
    }
  },
  mounted() {
    if(this.$route.query){
      this.addForm = this.$route.query;
      console.log(this.addForm)
    }
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.bg {
  background: #fff;
  padding: 5px;
}

.demo-form-inline {
  margin-top: 10px;
}
</style>